var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "semibold",
      class: _vm.color,
      on: {
        click: function($event) {
          return _vm.$emit("onClickAddPref")
        }
      }
    },
    [
      _vm.iconPosition === "left"
        ? _c("i", { staticClass: "icon-left", class: _vm.icon })
        : _vm._e(),
      _vm._v(" "),
      _c("span", [
        _vm._v(_vm._s(_vm.$l10n.__("Ajouter une préférence à mettre à jour")))
      ]),
      _vm._v(" "),
      _vm.iconPosition === "right"
        ? _c("i", { staticClass: "icon-right", class: _vm.icon })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }